<template>
  <div class="full-calendar-header">
    <div class="header-left">
      <slot name="header-left" />
    </div>
    <div class="header-center">
      <span class="el-icon-arrow-left" @click.stop="goPrev" />
      <span class="title">{{ title }}</span>
      <span class="el-icon-arrow-right" @click.stop="goNext" />
    </div>
    <div class="header-right">
      <slot name="header-right" />
    </div>
  </div>
</template>
<script>
// import dateFunc from './dateFunc'
import moment from 'moment'
export default {
  props: {
    currentMonth: {
      type: Object,
      default: () => {}
    },
    // titleFormat: {},
    // firstDay: {},
    // monthNames: {},
    locale: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      leftArrow: '<',
      rightArrow: '>'
    }
  },
  computed: {
    title() {
      if (!this.currentMonth) return
      return this.currentMonth.locale(this.locale).format('YYYY年MM月')
    }
  },
  methods: {
    goPrev() {
      var newMonth = moment(this.currentMonth).subtract(1, 'months').startOf('month')
      this.$emit('change', newMonth)
    },
    goNext() {
      var newMonth = moment(this.currentMonth).add(1, 'months').startOf('month')
      this.$emit('change', newMonth)
    }
  }
}
</script>
<style lang="scss">
.full-calendar-header{
  display: flex;
  align-items: center;
  .header-left,.header-right{
    flex:1;
  }
  .header-center{
    flex:3;
    text-align:center;
      font-size: 18px;
    .title{
      margin: 0 10px;
      color: #333;
    }
    .el-icon-arrow-left,.el-icon-arrow-right{
      cursor: pointer;
    }
  }
}
</style>
